import { render, staticRenderFns } from "./MWrapperFolderSpecial.vue?vue&type=template&id=74fb5872&scoped=true"
import script from "./MWrapperFolderSpecial.vue?vue&type=script&lang=js"
export * from "./MWrapperFolderSpecial.vue?vue&type=script&lang=js"
import style0 from "./MWrapperFolderSpecial.vue?vue&type=style&index=0&id=74fb5872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb5872",
  null
  
)

export default component.exports